import React from "react";

type Props = {
  title: string;
  description?: string;
  children: React.ReactNode;
};

// Groups related form fields into a bordered card with an accent-dot heading,
// so long chase forms read as sections instead of one uninterrupted column.
export default function FormSection({ title, description, children }: Props) {
  return (
    <div className="w-full rounded-2xl border border-edge bg-surface p-5 sm:p-6">
      <p className="flex items-center gap-2 text-[11px] font-semibold text-light-gray uppercase tracking-[0.14em]">
        <span className="w-1.5 h-1.5 rounded-full bg-accent shrink-0" />
        {title}
      </p>
      {description ? (
        <p className="mt-2 text-[13px] font-medium text-text-secondary">
          {description}
        </p>
      ) : null}

      <div className="mt-5 grid grid-cols-2 gap-x-6 gap-y-5">{children}</div>
    </div>
  );
}
